import contentJSON from '/static/data/content.json'

class PricingState {
	constructor(){
		console.log('construct');
		this.state = {
			"Service": {
		    	"type": -1,
		    	"coordinates": [],
		    	"preisrechner": []
		  	},
		  	"Contact": []
		};
	}

	setService(no){
		this.state.Service.type = no;
		console.log(this.state);
	}

	setPerimeterData(coords,area){
		this.state.Service.coordinates = [];
		let index = 0;
		while (coords.getAt(index) != undefined){
			this.state.Service.coordinates.push({"latitude": coords.getAt(index).toJSON().lat,"longitude":coords.getAt(index).toJSON().lng});
			index++;
		}
		this.state.Service.preisrechner = this.state.Service.preisrechner.filter(x => x.type != 48);
		this.state.Service.preisrechner.push({"type":48,"value":area});
		console.log(this.state);
	}

	setDataFromId(id,viewType){
		this.state.Service.preisrechner = this.state.Service.preisrechner.filter(x => x.type != id);
		this.state.Service.preisrechner.push({"type":id,"value":this.mapToType(id,document.getElementById(id).value,viewType)});
		console.log(this.state);
	}
	
	setData(id,value,viewType){
		this.state.Service.preisrechner = this.state.Service.preisrechner.filter(x => x.type != id);
		this.state.Service.preisrechner.push({"type":id,"value":this.mapToType(id,value,viewType)});
		console.log(this.state);
	}

	loadFormData(){
		return this.state.Service.preisrechner;
	}

	loadContactData(){
		return this.state.Service.Contact;
	}

	loadServiceData(){
		return this.state.Service.type;
	}

	loadPerimeterData(){
		return {"coordinates": this.state.Service.coordinates, "value": this.state.Service.preisrechner.find(x => x.type == 48) };
	}

	setContactDataFromId(id,viewType){
		this.state.Contact = this.state.Contact.filter(x => x.type != id);
		this.state.Contact.push({"type":id,"value":this.mapToType(id,document.getElementById(id).value,viewType)});
		console.log(this.state);
	}

	setContactData(id,value,viewType){
		this.state.Contact = this.state.Contact.filter(x => x.type != id);
		this.state.Contact.push({"type":id,"value":this.mapToType(id,value,viewType)});
		console.log(this.state);
	}

	toBool(x){
		return x == "Ja";
	}

	toInt(x){
		return parseInt(x);
	}

	toFloat(x){
		return parseFloat(x);
	}

	getOptionList(id){
		return contentJSON.Services[this.state.Service.type].preisrechner.find(elem => elem.type == id).values;
	}


	mapToType(id,data,viewType){
		let func;
		switch(viewType) {
			case 3:
				func = (x) => {return this.getOptionList(id).findIndex(t => t==x)};
				break;
			case 4:
				func = this.toBool;
	    		break;
	  		case 5:
	  			func = this.toInt;
	    		break;
	    	case 6:
	  			func = this.toFloat;
	    		break;
	  		default:
	  			return data;
		}
		return func(data);
	}

	sendData() {
		$.post( "https://api.vermflex.ch/offerservice/", JSON.stringify(state))
		.done(function( data ) {
			console.log( data );
		});
	}
}

export default PricingState;